"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParticipantTransactionItemStruct = exports.ParticipantTransactionRawItemStruct = exports.PARTICIPANT_TRANSACTION_CSV_FIELDS = exports.NoteTransactionItemStruct = exports.NoteTransactionRawItemStruct = exports.NOTE_TRANSACTION_CSV_FIELDS = exports.IbsTransactionCodeMap = exports.ParticipantActivityIbsActions = exports.NoteActivityIbsActions = void 0;
const zod_1 = require("zod");
const Utils = __importStar(require("./Utils"));
exports.NoteActivityIbsActions = ['increaseNoteBalance'];
exports.ParticipantActivityIbsActions = [
    'addParticipantToNote',
    'increaseParticipantNoteBalance',
];
exports.IbsTransactionCodeMap = {
    IncreaseGlobalNoteBalance: 750,
    IncreaseParticipantNoteBalance: 770,
};
// ****************************************************
//                IBS TRANSACTION REPORT
// ****************************************************
exports.NOTE_TRANSACTION_CSV_FIELDS = [
    {
        field: 'transaction_id', // Unique ID for the transaction
        type: 'string',
    },
    {
        field: 'account_note_number', // Both Account (External Facility ID) and Note (External Loan ID), with "-" separator
        type: 'string',
    },
    {
        field: 'effective_date', // Date of Accounting Transaction
        type: 'date',
    },
    {
        field: 'interest_paid_to', // Accrual End Date for Interest Payment Transactions
        type: 'optionalDate',
    },
    {
        field: 'report_date', // Date the Transaction was done
        type: 'date',
    },
    {
        field: 'transaction_code', // IBS Transaction Code
        type: 'integer',
    },
    {
        field: 'transaction_control_number', // IBS Transaction Grouping ID
        type: 'string',
    },
    {
        field: 'interest_amount',
        type: 'float',
    },
    {
        field: 'principal_amount',
        type: 'float',
    },
    {
        field: 'comment',
        type: 'optionalString',
    },
];
// Note that this should align with above note transaction CSV fields,
// and then representing the output structure of the data
exports.NoteTransactionRawItemStruct = zod_1.z.object({
    transaction_id: zod_1.z.string(),
    account_note_number: zod_1.z.string(),
    effective_date: Utils.ZodFullDateStrStruct,
    interest_paid_to: Utils.ZodFullDateStrStruct.nullable(),
    report_date: Utils.ZodFullDateStrStruct,
    transaction_code: zod_1.z.number().int().positive(),
    transaction_control_number: zod_1.z.string(),
    interest_amount: zod_1.z.number(),
    principal_amount: zod_1.z.number(),
    comment: zod_1.z.string().nullable(),
});
exports.NoteTransactionItemStruct = zod_1.z.object({
    transactionId: zod_1.z.string(),
    accountNumber: zod_1.z.string(),
    noteNumber: zod_1.z.string(),
    effectiveDate: Utils.ZodFullDateStrStruct,
    interestPaidToDate: Utils.ZodFullDateStrStruct.nullable(),
    reportDate: Utils.ZodFullDateStrStruct,
    transactionCode: zod_1.z.number().int().positive(),
    transactionControlNumber: zod_1.z.string(),
    interestAmount: zod_1.z.number(),
    principalAmount: zod_1.z.number(),
    comment: zod_1.z.string().nullable(),
    creditFacilityId: zod_1.z.string().nullable(),
    loanId: zod_1.z.string().nullable(),
    adminAgentOrganizationId: zod_1.z.string().nullable(),
    borrowerOrganizationId: zod_1.z.string().nullable(),
});
exports.PARTICIPANT_TRANSACTION_CSV_FIELDS = [
    {
        field: 'transaction_id', // Unique ID for the transaction
        type: 'string',
    },
    {
        field: 'account_note_number', // Both Account (External Facility ID) and Note (External Loan ID), with "-" separator
        type: 'string',
    },
    {
        field: 'participant_number', // Participant ID (for organization)
        type: 'string',
    },
    {
        field: 'effective_date', // Date of Accounting Transaction
        type: 'date',
    },
    {
        field: 'report_date', // Date the Transaction was done
        type: 'date',
    },
    {
        field: 'transaction_code', // IBS Transaction Code
        type: 'integer',
    },
    {
        field: 'transaction_control_number', // IBS Transaction Grouping ID
        type: 'string',
    },
    {
        field: 'interest_amount',
        type: 'float',
    },
    {
        field: 'principal_amount',
        type: 'float',
    },
    {
        field: 'comment',
        type: 'optionalString',
    },
];
// Note that this should align with above participant transaction CSV fields,
// and then representing the output structure of the data
exports.ParticipantTransactionRawItemStruct = zod_1.z.object({
    transaction_id: zod_1.z.string(),
    account_note_number: zod_1.z.string(),
    participant_number: zod_1.z.string(),
    effective_date: Utils.ZodFullDateStrStruct,
    report_date: Utils.ZodFullDateStrStruct,
    transaction_code: zod_1.z.number().int().positive(),
    transaction_control_number: zod_1.z.string(),
    interest_amount: zod_1.z.number(),
    principal_amount: zod_1.z.number(),
    comment: zod_1.z.string().nullable(),
});
exports.ParticipantTransactionItemStruct = zod_1.z.object({
    transactionId: zod_1.z.string(),
    accountNumber: zod_1.z.string(),
    noteNumber: zod_1.z.string(),
    participantNumber: zod_1.z.string(),
    effectiveDate: Utils.ZodFullDateStrStruct,
    reportDate: Utils.ZodFullDateStrStruct,
    transactionCode: zod_1.z.number().int().positive(),
    transactionControlNumber: zod_1.z.string(),
    interestAmount: zod_1.z.number(),
    principalAmount: zod_1.z.number(),
    comment: zod_1.z.string().nullable(),
    creditFacilityId: zod_1.z.string().nullable(),
    loanId: zod_1.z.string().nullable(),
    organizationId: zod_1.z.string().nullable(),
    adminAgentOrganizationId: zod_1.z.string().nullable(),
    borrowerOrganizationId: zod_1.z.string().nullable(),
});
//# sourceMappingURL=IbsIntegration.js.map